import React from 'react';
import { AppBar, SxProps, Toolbar } from '@mui/material';
import TranslationHubLogo from './TranslationHubLogo';
import Account from './Account';

const Header: React.FC = () => {


  return (
    <AppBar position="static" color="transparent" elevation={0} sx={styles.header}>
      <Toolbar sx={styles.headerToolbar}>
        <TranslationHubLogo />
        <Account />
      </Toolbar>
    </AppBar>
  );
};

const styles: Record<string, SxProps> = {
  header: {
    py: 3,
  },
  headerToolbar: {
    justifyContent: 'space-between',
    '@media (max-width: 768px)': {
      paddingInline: '8px',
    },
  },
  headerLogo: {
    height: '40px',
  },
};

export default Header;
